// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"ConfirmationModal__buttonsContainer___uAR62","confirmationModal":"ConfirmationModal__confirmationModal___YcTI2"};